import { useSelector } from 'react-redux';

const NawyNowDocumentIcon = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  return isMobile ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M14.2715 7.29594H12.3448C10.7648 7.29594 9.47815 6.00927 9.47815 4.42927V2.5026C9.47815 2.13594 9.17815 1.83594 8.81148 1.83594H5.98482C3.93148 1.83594 2.27148 3.16927 2.27148 5.54927V11.4559C2.27148 13.8359 3.93148 15.1693 5.98482 15.1693H11.2248C13.2782 15.1693 14.9382 13.8359 14.9382 11.4559V7.9626C14.9382 7.59594 14.6382 7.29594 14.2715 7.29594ZM8.79148 11.0226L7.45815 12.3559C7.41148 12.4026 7.35148 12.4426 7.29148 12.4626C7.23148 12.4893 7.17148 12.5026 7.10482 12.5026C7.03815 12.5026 6.97815 12.4893 6.91815 12.4626C6.86482 12.4426 6.81148 12.4026 6.77148 12.3626C6.76482 12.3559 6.75815 12.3559 6.75815 12.3493L5.42482 11.0159C5.23148 10.8226 5.23148 10.5026 5.42482 10.3093C5.61815 10.1159 5.93815 10.1159 6.13148 10.3093L6.60482 10.7959V8.0026C6.60482 7.72927 6.83148 7.5026 7.10482 7.5026C7.37815 7.5026 7.60482 7.72927 7.60482 8.0026V10.7959L8.08482 10.3159C8.27815 10.1226 8.59815 10.1226 8.79148 10.3159C8.98482 10.5093 8.98482 10.8293 8.79148 11.0226Z"
        fill="#1A2028"
      />
      <path
        d="M12.2259 6.37365C12.8592 6.38032 13.7392 6.38032 14.4926 6.38032C14.8726 6.38032 15.0726 5.93365 14.8059 5.66699C13.8459 4.70032 12.1259 2.96032 11.1392 1.97365C10.8659 1.70032 10.3926 1.88699 10.3926 2.26699V4.59365C10.3926 5.56699 11.2192 6.37365 12.2259 6.37365Z"
        fill="#1A2028"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M13.667 7.10844H11.7403C10.1603 7.10844 8.87366 5.82177 8.87366 4.24177V2.3151C8.87366 1.94844 8.57366 1.64844 8.20699 1.64844H5.38033C3.32699 1.64844 1.66699 2.98177 1.66699 5.36177V11.2684C1.66699 13.6484 3.32699 14.9818 5.38033 14.9818H10.6203C12.6737 14.9818 14.3337 13.6484 14.3337 11.2684V7.7751C14.3337 7.40844 14.0337 7.10844 13.667 7.10844ZM8.18699 10.8351L6.85366 12.1684C6.80699 12.2151 6.74699 12.2551 6.68699 12.2751C6.62699 12.3018 6.56699 12.3151 6.50033 12.3151C6.43366 12.3151 6.37366 12.3018 6.31366 12.2751C6.26033 12.2551 6.20699 12.2151 6.16699 12.1751C6.16033 12.1684 6.15366 12.1684 6.15366 12.1618L4.82033 10.8284C4.62699 10.6351 4.62699 10.3151 4.82033 10.1218C5.01366 9.92844 5.33366 9.92844 5.52699 10.1218L6.00033 10.6084V7.8151C6.00033 7.54177 6.22699 7.3151 6.50033 7.3151C6.77366 7.3151 7.00033 7.54177 7.00033 7.8151V10.6084L7.48033 10.1284C7.67366 9.9351 7.99366 9.9351 8.18699 10.1284C8.38033 10.3218 8.38033 10.6418 8.18699 10.8351Z"
        fill="white"
      />
      <path
        d="M11.6204 6.18615C12.2538 6.19282 13.1338 6.19282 13.8871 6.19282C14.2671 6.19282 14.4671 5.74615 14.2004 5.47949C13.2404 4.51282 11.5204 2.77282 10.5338 1.78615C10.2604 1.51282 9.78711 1.69949 9.78711 2.07949V4.40615C9.78711 5.37949 10.6138 6.18615 11.6204 6.18615Z"
        fill="white"
      />
    </svg>
  );
};
export default NawyNowDocumentIcon;
